import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {DbModalService} from "../../../../../../modules/modal/modal";
import {first} from "rxjs/operators";
import {BoosterService} from "../../../services/booster.service";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import {Subject} from "rxjs";
import {UserSubscription} from "../../../../../../user/user-subscription";
import {DialogService} from "../../../../../../../ng2-bootstrap-modal/dialog.service";
import {ActivatedRoute, Router} from "@angular/router";
import {IBoosterStats} from "../../../../../../store/reducers/booster.reducer";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {WebsiteService} from "../../../../../website.service";
import {IOPagesData} from "../../../mappers/io-list";
import {ImageOptimizerSuccessComponent} from "../../../image-optimizer-success/image-optimizer-success.component";
import {Website} from "../../../../website";
import {
  NotificationDialogComponent
} from "../../../../../../shared/components/dialogs/notification-dialog/notification-dialog.component";

@Component({
    selector: 'db-image-optimize-media-library',
    templateUrl: './image-media-library.component.html',
    styleUrls: ['./image-media-library.component.scss'],
    standalone: false
})
export class ImageMediaLibraryComponent implements OnChanges, OnInit, OnDestroy {

  @Input() currentSubscription: UserSubscription;
  @Input() website: Website;
  @Input() websiteId: number;
  @Input() optimizedImages: IOPagesData[];
  @Input() optimizeImagesStats: any;
  @Input() optimizedPagesLoading: boolean;
  @Input() boosterPluginIsActive: boolean;
  @Input() pageLayout: boolean;
  @Input() inProgress: boolean;
  @Input() loading: boolean;
  @Input() stats: IBoosterStats;
  @Input() currentScore: any;

  public websiteHosted: boolean;
  public websiteServerType: string;
  public optimizationError: boolean = false;
  @Output() getReport: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _router: Router,
    private _dbModal: DbModalService,
    private _boosterService: BoosterService,
    private _websiteService: WebsiteService,
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _route: ActivatedRoute,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['optimizedImages'] && !changes['optimizedImages'].firstChange) {
      const currentValue = changes['optimizedImages'].currentValue;
      const previousValue = changes['optimizedImages'].previousValue;
      if (currentValue && previousValue && currentValue.length !== previousValue.length) {
        this.showIOSuccessModal();
      }
    }
  }

  ngOnInit() {
    this._initData();
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  public optimizeImages(): void {
    if (!!this.inProgress) {
      this._showOptimizingInProgressDialog();
      return;
    }
    this.sendEvent('Optimize Button click');
    this.loading = true;
    this._boosterService.optimizeImages(this.websiteId)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        if (response.success) {
          this.getReport.emit(true);
        } else {
          this.optimizationError = true;
          const analyticsData = {
            eventCategory: 'Dashboard Error',
            eventAction: 'Something Went Wrong',
            eventLabel: 'IO: media library tab',
            websiteId: this.websiteId
          };
          this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
        }
      });
  }

  public sendEvent(action: string): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: action,
      eventLabel: 'IO: media library tab',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _showOptimizingInProgressDialog(): void {
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: 'Image optimization in progress',
      message: 'Please wait until the ongoing image optimization process<br/> is complete before beginning another' +
        ' optimization.',
      buttonText: 'Got It',
      hasCloseButton: true,
      buttonColor: 'green'
    });
  }

  private _initData(): void {
    const website = this._route.snapshot.data['pageId'] === 'image-optimizer' ? this._route.snapshot.parent.data['website'] : this._route.snapshot.parent.parent.data['website'];
    this.websiteHosted = !!website.domain_hash;
    this.websiteServerType = website.serverType;
  }

  private showIOSuccessModal(): void {
    if (this._dbModal.hasOpenModals() || this._dialogService.hasOpenedDialog()) {
      return;
    }
    if (this.boosterPluginIsActive) {
      this._dialogService.addDialog(NotificationDialogComponent, {
        header: 'Images are successfully optimized',
        message: 'Check your website and see the results.',
        buttonText: 'Got It',
        hasCloseButton: true,
        buttonColor: 'green'
      });
      return;
    }
    const modal = this._dbModal.open(ImageOptimizerSuccessComponent, {height: 600, width: 940});
    modal.componentInstance.report = this.optimizedImages[0];
    modal.componentInstance.website = this.website;
    modal.componentInstance.currentScore = this.currentScore;
  }

}
